// extracted by mini-css-extract-plugin
module.exports = {"seo-content":"seo-content_seo-content__Q7zSV"};